import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'
import FileUploadApi from './FileUpload.api.js'

export default {
  getMediaItems(establishmentId) {
    return passThroughAxios.get('media', { params: { establishmentId } })
  },
  async uploadMediaItem(mediaType, file, establishmentId, targetDealerId = null) {
    const { token } = await FileUploadApi.uploadToStaging(file)
    const params = { fileToken: token, establishmentId }
    if (targetDealerId) params.targetDealerId = targetDealerId
    return passThroughAxios.post(`media/${mediaType}/upload`, null, { params })
  },
  getMediaHistory(mediaType, establishmentId, targetDealerId = null) {
    const params = { establishmentId }
    if (targetDealerId) params.targetDealerId = targetDealerId
    return passThroughAxios.get(`media/${mediaType}/history`, { params })
  },
  restoreMediaVersion(mediaType, versionId, establishmentId, targetDealerId = null) {
    const params = { versionId, establishmentId }
    if (targetDealerId) params.targetDealerId = targetDealerId
    return passThroughAxios.post(`media/${mediaType}/restore`, null, { params })
  },
  previewMediaItem(mediaType, file) {
    const formData = new FormData()
    formData.append('file', file)
    return axios.post('PreviewMediaHtml', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { mediaType },
      responseType: 'text',
    })
  },
}
